import { render, staticRenderFns } from "./LPRAlertModal.vue?vue&type=template&id=28425c20&scoped=true"
import script from "./LPRAlertModal.vue?vue&type=script&lang=js"
export * from "./LPRAlertModal.vue?vue&type=script&lang=js"
import style0 from "./LPRAlertModal.vue?vue&type=style&index=0&id=28425c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28425c20",
  null
  
)

export default component.exports